module.exports = __webpack_public_path__ + "5c740c6f3db2909a299343656bcd4248.svg";